<script lang="ts" setup>
import { onUnmounted } from 'vue';
import { useMainStore } from '~/store';

const store = useMainStore();

const pngPath = './assets/dino.png';

onUnmounted(() => {
  store.resetState();
})

</script>

<template>
  <div id="error-view">
    <h1>CONNECTION ERROR</h1>
    <img :src="pngPath" alt="dino" width="200" />
  </div>
</template>

<style lang="scss">
#error-view {
  margin: 0 auto;
  text-align: center;
}
</style>
